import { Typography } from '@mui/material'
import React, { Fragment, memo } from 'react'
import { colors } from 'src/theme'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { customerComplianceStepTitles } from 'src/constants/customer/constants'
import { CustomerCollectedDataType } from 'src/constants/customer/enums'
import { customerComplianceStepIcons } from 'src/constants/customer/icons'

interface Props {
  isStartSigningLoading?: boolean
  isSigningFallbackLoading?: boolean
  isSigningIframeCrashed?: boolean
  isSigningEnvelopeAvailable?: boolean
  onStartSigning(): void
  onStartSigningFallback(): void
}

const CustomerSignContractGetStartedComponent = ({
  isStartSigningLoading,
  isSigningFallbackLoading,
  isSigningIframeCrashed,
  isSigningEnvelopeAvailable,
  onStartSigning,
  onStartSigningFallback,
}: Props) => (
  <Fragment>
    <div>
      <div css={tw`px-4 pt-6 py-2`}>
        {customerComplianceStepIcons[CustomerCollectedDataType.GigsafeContract]}
        <Typography variant="h4" css={tw`mt-2 mb-2`}>
          {customerComplianceStepTitles[CustomerCollectedDataType.GigsafeContract]}
        </Typography>
        <div css={tw`w-full h-[1px] bg-[#EDEDED]`} />
        <Typography variant="body2" color={colors.SHADES_GREY_400} css={tw`mb-4 mt-2`}>
          Easily sign your contracts and documents with DocuSign. Just tap the button below to get
          started.
          {isSigningEnvelopeAvailable ? (
            <Typography variant="body2" color={colors.SHADES_GREY_400} css={tw`mt-4`}>
              If you are experiencing issues with the signing process, please try{' '}
              <strong>Sign the contract in a new tab</strong> instead.
            </Typography>
          ) : null}
        </Typography>
      </div>
    </div>
    <div css={tw`px-4 py-3 mt-auto`}>
      {isSigningIframeCrashed ? (
        <Button
          data-testid="customer-account-onboarding-sign-contract-new-tab-btn"
          color="light"
          size="small"
          loading={isSigningFallbackLoading}
          className={tw`w-full`}
          onClick={onStartSigningFallback}
        >
          Sign the contract in a new tab
        </Button>
      ) : (
        <Button
          data-testid="customer-account-onboarding-sign-contract-primary-btn"
          className={tw`w-full`}
          size="small"
          loading={isStartSigningLoading}
          onClick={onStartSigning}
        >
          {isSigningEnvelopeAvailable ? 'Sign the contract' : 'Get started'}
        </Button>
      )}
      {isSigningEnvelopeAvailable && !isSigningIframeCrashed ? (
        <Button
          data-testid="customer-account-onboarding-sign-contract-new-tab-secondary-btn"
          className={tw`w-full mt-4`}
          color="light"
          size="small"
          loading={isSigningFallbackLoading}
          onClick={onStartSigningFallback}
        >
          Sign the contract in a new tab
        </Button>
      ) : null}
    </div>
  </Fragment>
)

export const CustomerSignContractGetStarted = memo(CustomerSignContractGetStartedComponent)
